import React, {useEffect, useState} from "react";
import {Title} from "../../../components/components";
import {
  useAddDefaultCmpConfigConsentableMutation,
  useAddDefaultCmpConfigVendorMutation, useCreateDefaultCmpConfigPurposeMutation,
  useCreateDefaultCmpConfigVendorMutation,
  useDeleteDefaultCmpConfigVendorMutation,
  useGetDefaultCmpConfigPurposesQuery,
  useGetDefaultCmpConfigQuery,
  useGetDefaultCmpConfigVendorsQuery,
  useLazyGetDefaultCmpAvailableVendorsQuery, useRemoveDefaultCmpConfigConsentableMutation,
  useUpdateDefaultCmpConfigMutation, useUpdateDefaultCmpConfigPurposeMutation,
  useUpdateDefaultCmpConfigVendorMutation
} from "../../../api/cmpDefaultApiSlice";
import {useTranslation} from "react-i18next";
import CmpConfiguration from "../../../components/cmp/CmpConfiguration";

export default function CmpDefaultConfiguration(props) {
  const { i18n } = useTranslation()

  const {data: cmpConfig = {}, isSuccess: isConfigSuccess, isFetching: isConfigLoading} = useGetDefaultCmpConfigQuery()
  const {data: purposes = [], isSuccess: isPurposesSuccess, isFetching: isPurposesLoading} = useGetDefaultCmpConfigPurposesQuery({lang: i18n.language})
  const {data: vendors = {}, isSuccess: isVendorsSuccess, isFetching: isVendorsLoading} = useGetDefaultCmpConfigVendorsQuery({lang: i18n.language})
  const [getAvailableVendors, {data: availableVendors = [], isLoading: isAvailableVendorsLoading},] = useLazyGetDefaultCmpAvailableVendorsQuery()
  const [updateCmpConfig] = useUpdateDefaultCmpConfigMutation()
  const [addVendor] = useAddDefaultCmpConfigVendorMutation()
  const [updateVendor] = useUpdateDefaultCmpConfigVendorMutation()
  const [createVendor] = useCreateDefaultCmpConfigVendorMutation()
  const [removeVendor] = useDeleteDefaultCmpConfigVendorMutation()
  const [addConsentable] = useAddDefaultCmpConfigConsentableMutation()
  const [createPurpose] = useCreateDefaultCmpConfigPurposeMutation()
  const [updatePurpose] = useUpdateDefaultCmpConfigPurposeMutation()
  const [removeConsentable] = useRemoveDefaultCmpConfigConsentableMutation()

  const vendorsLoaderProps = {isSuccess: isVendorsSuccess, isLoading: isVendorsLoading}
  const purposesLoaderProps = {isSuccess: isPurposesSuccess, isLoading: isPurposesLoading}
  const cmpConfigLoaderProps = {isSuccess: isConfigSuccess, isLoading: isConfigLoading}

  const cmpConfigurationProps = {
    cmpConfig: cmpConfig,
    updateCmpConfig: updateCmpConfig,
    vendors: vendors,
    availableVendors: availableVendors,
    getAvailableVendors: getAvailableVendors,
    updateVendor: updateVendor,
    createVendor: createVendor,
    addVendor: addVendor,
    removeVendor: removeVendor,
    vendorsLoaderProps: {...vendorsLoaderProps},
    purposes: purposes,
    languages: cmpConfig.languages,
    isAvailableVendorsLoading: isAvailableVendorsLoading,
    addConsentable: addConsentable,
    createPurpose: createPurpose,
    updatePurpose: updatePurpose,
    removeConsentable: removeConsentable,
    purposesLoaderProps: purposesLoaderProps,
    cmpConfigLoaderProps: cmpConfigLoaderProps
  }

  return (
    <>
      <Title main="CMP" sub="Configuration"/>
      <CmpConfiguration {...cmpConfigurationProps} />
    </>
  )
}
